import { rydeColors } from "./ryde-colors";

export const getMenuItemColor = (isActive: boolean | undefined): string =>
  isActive ? rydeColors.leftMenuHighlight : rydeColors.white;
